// src/pages/Reviews.js
import React, { useState } from 'react';
import BarChart from '../components/charts/BarChart';
import LineChart from '../components/charts/LineChart';

const Reviews = () => {
  const [sortBy, setSortBy] = useState('date');

  const distributionData = {
    labels: ['1 Star', '2 Stars', '3 Stars', '4 Stars', '5 Stars'],
    datasets: [
      {
        label: 'Number of Reviews',
        data: [5, 3, 10, 20, 32],
        backgroundColor: '#ba00ba',
      },
    ],
  };

  const reviewsOverTime = {
    labels: ['2021', '2022', '2023', '2024', '2025'],
    datasets: [
      {
        label: 'Reviews Over Time',
        data: [500, 1500, 2500, 3000, 4500],
        borderColor: '#ba00ba',
      },
    ],
  };

  // Demo reviews
  const reviewsData = [
    {
      name: 'Tim Cook',
      date: '2025-01-08',
      content: 'Great service, quick, polite and professional valet!',
      rating: 4,
      tip: 10,
    },
    {
      name: 'Grace Hopper',
      date: '2025-01-10',
      content: 'Valet was slow but courteous. Overall, decent.',
      rating: 3,
      tip: 5,
    },
    {
      name: 'Alan Turing',
      date: '2025-02-01',
      content: 'Excellent. Car was retrieved promptly!',
      rating: 5,
      tip: 12,
    },
    {
      name: 'Ada Lovelace',
      date: '2025-01-25',
      content: 'Valet lost my keys for 10 minutes... but apologized a lot.',
      rating: 2,
      tip: 2,
    },
    {
      name: 'Margaret Hamilton',
      date: '2025-01-22',
      content: 'Smooth experience, no issues at all. Will use again!',
      rating: 5,
      tip: 15,
    },
  ];

  // Sorting
  const sortedReviews = [...reviewsData].sort((a, b) => {
    if (sortBy === 'date') {
      return new Date(b.date) - new Date(a.date);
    }
    return b.rating - a.rating;
  });

  // Average rating
  const totalRating = reviewsData.reduce((acc, r) => acc + r.rating, 0);
  const avgRating = (totalRating / reviewsData.length).toFixed(1);

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
        {/* LEFT: AVERAGE REVIEW + DISTRIBUTION */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}
          >
            <h3 style={{ marginBottom: '10px' }}>Average Review</h3>
            <div style={{ marginTop: '10px', fontSize: '1.3rem', color: '#444' }}>
              {avgRating} Stars
            </div>
          </div>
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}
          >
            <h3 style={{ marginBottom: '10px' }}>Distribution of Reviews</h3>
            <div
              style={{
                height: '240px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <BarChart chartData={distributionData} />
            </div>
          </div>
        </div>

        {/* RIGHT: REVIEWS OVER TIME (Line) */}
        <div
          style={{
            flex: 1,
            background: '#fff',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          }}
        >
          <h3 style={{ marginBottom: '10px' }}>Reviews Over Time</h3>
          <div
            style={{
              height: '300px',
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div style={{ width: '600px', height: '300px' }}>
              <LineChart lineData={reviewsOverTime} />
            </div>
          </div>
        </div>
      </div>

      {/* REVIEWS TABLE */}
      <div
        style={{
          background: '#fff',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ marginBottom: '15px' }}>
          <span style={{ marginRight: '10px', fontWeight: 'bold', color: '#ba00ba' }}>Sort By:</span>
          <button
            style={{
              background: sortBy === 'date' ? '#ba00ba' : '#ddd',
              color: sortBy === 'date' ? '#fff' : '#444',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              marginRight: '5px',
              cursor: 'pointer',
            }}
            onClick={() => setSortBy('date')}
          >
            Date
          </button>
          <button
            style={{
              background: sortBy === 'rating' ? '#ba00ba' : '#ddd',
              color: sortBy === 'rating' ? '#fff' : '#444',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
            onClick={() => setSortBy('rating')}
          >
            Rating
          </button>
        </div>

        <h2 style={{ marginBottom: '10px' }}>All Reviews</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <th style={{ textAlign: 'left', padding: '8px' }}>User</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Date</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Rating</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Tip ($)</th>
              <th style={{ textAlign: 'left', padding: '8px' }}>Review</th>
            </tr>
          </thead>
          <tbody>
            {sortedReviews.map((r, idx) => {
              const dateStr = new Date(r.date).toLocaleDateString();
              return (
                <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                  <td
                    style={{
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <img
                      src="https://media.sproutsocial.com/uploads/2022/06/profile-picture.jpeg"
                      alt="User"
                      style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                    />
                    <span>{r.name}</span>
                  </td>
                  <td style={{ padding: '8px' }}>{dateStr}</td>
                  <td style={{ padding: '8px' }}>{r.rating} / 5</td>
                  <td style={{ padding: '8px' }}>{r.tip}</td>
                  <td style={{ padding: '8px' }}>{r.content}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Reviews;
